export default __webpack_public_path__ + "static/media/qr-tablet.4ce765a6.jpg";